export default __webpack_public_path__ + "static/media/avlare_beanie.9e4123fe.jpg";